import { Popover } from "antd";
import styles from "./index.module.less";
/**
 * 覆盖样式
 * @param {import("antd").PopoverProps} props
 * @returns
 */
export default function HBPopover(props) {
  return (
    <Popover
      {...props}
      overlayClassName={styles.popover + " " + props.overlayClassName}
    />
  );
}
